export default __webpack_public_path__ + "images/I2.9cbd3da.png";